import { Container, Grid, Stack, Typography } from "@mui/material";
import ScreenBanner from "../../../../components/ScreenBanner";
import AguardandoSeparacao from "./AguardandoSeparacao";
import Expedicoes from "./Expedicoes";
import SepararDialog from "./SepararDialog";
import { useContext, useState } from "react";
import { IDataItensExpedir } from "../../../../types/api/estoque/pesquisar-itens-para-expedir";
import SelectQuery from "../../../../components/SelectQuery";
import { IDataLojas } from "../../../../types/api/geral/pesquisar-lojas";
import { AuthContext } from "../../../../contexts/AuthContext";

export default function ExpedicaoPedidos() {

    const { userPerfilComLoja } = useContext(AuthContext);

    const [itensParaSeparar, setItensParaSeparar] = useState<IDataItensExpedir[] | null>();
    const [lojaSelecionada, setLojaSelecionada] = useState<IDataLojas>(userPerfilComLoja?.loja || { id: 0, nome: "" })

    return (
        <>
            <ScreenBanner color="#1E2E6B" title="Estoque" />

            <Container sx={{ mt: 6 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="h5" align="center" mb={2}>Expedição de pedidos</Typography>

                    <SelectQuery
                        defaultValue={[lojaSelecionada]}
                        query="pesquisar-lojas"
                        type="field"
                        label="Loja"
                        titleModal="Selecionar Loja"
                        emptyLabel="-"
                        multiple={false}
                        permitirLimpar={false}
                        returnOnlyId={false}
                        autoSelectFirst
                        onChange={(values) => {
                            setLojaSelecionada(values[0]);
                        }}
                        extraParams={{ somente_vinculadas: Boolean(userPerfilComLoja?.loja) }}
                    />
                </Stack>

                <Grid container spacing={2} mt={2}>
                    <Grid size={{xs: 12, md: 4}}>
                        <AguardandoSeparacao
                            lojaSelecionadaId={lojaSelecionada.id}
                            handleSeparar={(itens) => setItensParaSeparar(itens)}
                        />
                    </Grid>

                    <Grid size={{xs: 12, md: 8}}>
                        <Expedicoes lojaSelecionadaId={lojaSelecionada.id} />
                    </Grid>
                </Grid>
            </Container>

            {
                itensParaSeparar &&
                <SepararDialog
                    items={itensParaSeparar}
                    open={itensParaSeparar ? true : false}
                    handleClose={() => setItensParaSeparar(null)}
                />
            }
        </>
    )
}